export const FETCH_AR_INCOICE_REQUEST = 'FETCH_AR_INCOICE_REQUEST';
export const FETCH_AR_INCOICE_SUCCESS = 'FETCH_AR_INCOICE_SUCCESS'

export const FETCH_AR_INCOICE_VIEW_REQUEST = 'FETCH_AR_INCOICE_VIEW_REQUEST';
export const FETCH_AR_INCOICE_VIEW_SUCCESS = 'FETCH_AR_INCOICE_VIEW_SUCCESS';